import React, { useState, useEffect } from "react";
import {
  Modal,
  Loading,
  DatePicker,
  Input,
  Typography,
  Button,
} from "../../../core";
import styled from "styled-components";
import { Form, Row, Col, Select, Space } from "antd";
import { useForm } from "antd/lib/form/util";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import moment from "moment";
import { MixStyle } from "../../../styles";
import { updateDispatch } from "../../../helper/utils/api/dispatch";

const { Option } = Select;
const Notify_Utils = require("../../../helper/utils/Notification");

const layout = {
  labelCol: {
    span: 24,
  },
  wrapperCol: {
    span: 24,
  },
};

const StyledForm = styled(Form)`
  label {
    ${MixStyle.Label};
  }
`;

const EditClothReturnModal = ({
  editClothReturnModal,
  closeModal,
  recordToEdit,
  getDispatchesOfCurrentContract,
}) => {
  let [form] = useForm();

  const [state, setState] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [updatedValue, setUpdatedValue] = React.useState({});

  console.log("::recordToEdit", recordToEdit);

  useEffect(() => {
    let currentDispatch = {
      ...recordToEdit,
      clothReturnDate: moment(recordToEdit.clothReturnDate),
    };
    setState(currentDispatch);
  }, [recordToEdit]);

  const closeModalHandler = () => {
    closeModal("editClothReturnModalOpen");
  };

  const onFinish = () => {
    editDispatchApiFun();
  };

  const onValuesChange = (changedValues, valuse) => {
    console.log("changedValues", changedValues);
    console.log("valuse", valuse);

    if (changedValues.glrReceived) {
      let netPass =
        parseInt(state && state.kachiQuantity && state.kachiQuantity) -
        parseInt(state && state.lShort && state.lShort) -
        parseInt(changedValues.glrReceived);
      form.setFieldsValue({
        netPass,
      });

      setUpdatedValue((prev) => ({
        ...prev,
        ...changedValues,
        netPass,
      }));
    } else if (changedValues.clothReturnVariations) {
      setUpdatedValue((prev) => ({
        ...prev,
        clothReturnVariations: valuse.clothReturnVariations,
      }));
    } else {
      setUpdatedValue((prev) => ({
        ...prev,
        ...changedValues,
      }));
    }
  };
  const onFinishFailed = () => {};

  const editDispatchApiFun = async () => {
    debugger;
    let contractId = state.contractId;
    setIsLoading(true);
    try {
      let dispatchIdToEdit = state && state._id && state._id;
      let response = await updateDispatch({
        contractId,
        dispatchIdToEdit,
        updatedValue,
      });

      Notify_Utils.openNotificationWithIcon("success", response.data.message);
      closeModalHandler();
      setIsLoading(false);
      getDispatchesOfCurrentContract();
    } catch (error) {
      setIsLoading(false);
      Notify_Utils.openNotificationWithIcon(
        "error",
        "Error While update Dispatch"
      );
      console.log("error while update", error);
    }
  };

  return (
    <Modal
      closable={true}
      visible={editClothReturnModal}
      okText="Add"
      maxwidth="800px"
      footer={false}
      onCancel={closeModalHandler}
      tittle="Edit Cloth Return"
    >
      {isLoading ? <Loading /> : null}
      <StyledForm
        autocomplete="off"
        form={form}
        {...layout}
        name="basic"
        initialValues={state}
        onFinish={onFinish}
        onValuesChange={onValuesChange}
        onFinishFailed={onFinishFailed}
      >
        <Row
          gutter={{ xs: 0, sm: 48, md: 48, lg: 48 }}
          type="flex"
          justify="center"
        >
          <Col span={24}>
            <Form.Item
              label="Date"
              name="clothReturnDate"
              rules={[
                {
                  required: true,
                  message: "Please Set Date!",
                },
              ]}
            >
              <DatePicker />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item
              label="G/L/R Received"
              name="glrReceived"
              rules={[
                {
                  required: true,
                  message: "Please Enter G/L/R Received ",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label="Net Pass"
              name="netPass"
              rules={[
                {
                  required: true,
                  message: "Please Enter  Net Pass!",
                },
              ]}
            >
              <Input disabled />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              label="P patch parchi #"
              name="packiParchiNumber"
              rules={[
                {
                  required: true,
                  message: "Please Enter  P patch parchi #!",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col xs={24}>
            <Form.List name="clothReturnVariations">
              {(fields, { add, remove }) => {
                return (
                  <div>
                    {fields.map((field, index) => (
                      <Space
                        key={field.key}
                        style={{ display: "flex", marginBottom: 8 }}
                        align="start"
                      >
                        <Form.Item
                          {...field}
                          name={[field.name, "category"]}
                          fieldKey={[field.fieldKey, "category"]}
                          rules={[
                            { required: true, message: "Plz Enter category" },
                          ]}
                        >
                          <Select defaultValue="">
                            <Option value="">Select Category</Option>
                            <Option value="A">Category A</Option>
                            <Option value="B">Category B</Option>
                            <Option value="C">Category C</Option>
                          </Select>
                        </Form.Item>
                        <Form.Item
                          {...field}
                          name={[field.name, "quantity"]}
                          fieldKey={[field.fieldKey, "quantity"]}
                          rules={[
                            { required: true, message: "Input Quanitity" },
                          ]}
                          style={{ width: "100%" }}
                        >
                          <Input
                            placeholder="Quanitity"
                            // prefix={<UserOutlined />}
                          />
                        </Form.Item>
                        <Form.Item
                          {...field}
                          name={[field.name, "rate"]}
                          fieldKey={[field.fieldKey, "rate"]}
                          rules={[{ required: true, message: "Input Rate" }]}
                          style={{ width: "100%" }}
                        >
                          <Input
                            placeholder="Rate"
                            // prefix={<UserOutlined />}
                          />
                        </Form.Item>

                        {/* {fields.length > 1 ? ( */}
                        <MinusCircleOutlined
                          onClick={() => {
                            remove(field.name);
                          }}
                        />
                        {/* ) : null} */}
                      </Space>
                    ))}
                    <Form.Item>
                      <Button
                        width="187px"
                        margin="auto"
                        fontSize="16px"
                        weight="500"
                        height="auto"
                        bg="#ba3d79"
                        onClick={() => {
                          add();
                          // setVariant(true);
                        }}
                      >
                        <PlusOutlined /> Add Variation
                      </Button>
                    </Form.Item>
                  </div>
                );
              }}
            </Form.List>
          </Col>
          <Col xs={24} sm={24}>
            <Row type="flex" justify="center">
              <Col sm={10}>
                <Button bg="#404E67" type="primary" htmlType="submit">
                  <Typography
                    text="Add"
                    as="h5"
                    noMargin
                    weight="bold"
                    align="center"
                    color="white"
                  />
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
      </StyledForm>
    </Modal>
  );
};

export default EditClothReturnModal;
